<template>
  <default-modal
    ref="modal"
    v-model="modalOpened"
    name="team-switcher"
    width="xs"
    :title="$t('change_team')"
    :body-classes="['no-padding']"
  >
    <template slot="content">
      <q-list no-border link>
        <q-item
          v-close-overlay
          v-for="team in teams"
          class="team-entry q-px-lg"
          :key="team.id"
          @click.native="handleChangeTeam(team.id)"
        >
          <q-item-side left>
            <team-logo :team="team" class="q-headline" height="64px" width="64px"/>
          </q-item-side>

          <q-item-main class="q-pl-md">
            <div class="row items-center justify-between">
              <span class="q-title text-grey-8 ellipsis col">{{ team.name }}</span>

              <q-chip
                v-if="isActiveTeam(team)"
                color="white"
                text-color="positive"
                class="positive-tag on-right q-px-sm col-auto"
                dense
                rounded
              >
                {{ $t('active') }}
              </q-chip>
            </div>

            <span class="q-body-2">{{ $t('role_' + team.role_id) }}</span>
          </q-item-main>
        </q-item>
      </q-list>
    </template>

    <template slot="footer">
      <div class="full-width row justify-between">
        <q-btn
          flat
          dense
          color="primary"
          icon="add"
          @click="handleCreateTeam"
        >
          &nbsp;{{ $t('new_team') }}
        </q-btn>

        <q-btn color="primary" @click="handleClose">&nbsp;{{ $t('close') }}</q-btn>
      </div>
    </template>
  </default-modal>
</template>

<script>
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import TeamLogo from 'components/Common/TeamLogo.vue'
  import { mapActions } from 'vuex'

  export default {
    props: {
      teams: {
        type: Array,
        required: true
      },
      activeTeam: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        modalOpened: false
      }
    },

    methods: {
      ...mapActions(['changeTeam']),

      show () {
        this.modalOpened = true
      },

      handleChangeTeam (teamId) {
        this.changeTeam(teamId)
          .then((team) => {
            this.$router.push({ name: 'dashboard', params: { 'teamId': team.id } })
          })
          .catch(() => {
            this.$q.notify({ message: this.$t('change_team_error'), type: 'negative' })
          })
      },

      handleCreateTeam () {
        this.modalOpened = false

        this.$emit('createTeam')
      },

      handleClose () {
        this.modalOpened = false
      },

      isActiveTeam (team) {
        return this.activeTeam ? this.activeTeam.id === team.id : false
      }
    },

    components: {
      DefaultModal,
      TeamLogo
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .team-entry:hover
    background-color: $grey-1 !important
</style>
